// @ts-nocheck
import 'lib/Init';
import Vue from 'vue';
import { ValidationProvider, localize, extend, ValidationObserver } from "vee-validate";
import Cookies from 'js-cookie';
import { axios } from 'lib/Init';
import Notification from 'lib/Notification';
import Swal from 'lib/SwalExtension';
import { __, navigateToUrl } from 'lib/Utilities';
import PurchaseFlowMixin from 'lib/mixins/PurchaseFlowMixin';
import LicenseQuantity from 'components/smb/LicenseQuantity.vue';
import BusinessDetails from 'components/smb/BusinessDetails.vue';
import BusinessUrl from 'components/smb/BusinessUrl.vue';
import BillingDetails from 'components/smb/BillingDetails.vue';
import Terms from 'components/smb/Terms.vue';
import CardInformation from 'components/smb/CardInformation.vue';
import DetailVerification from 'components/smb/DetailVerification.vue';
import Invoice from 'components/smb/Invoice.vue';
import Contact from 'components/smb/Contact.vue';
const dictionary = {
    en: {
        messages: {
            required(fieldName) {
                if (fieldName === 'promotion_code') {
                    return __('errors.invalid_promo_code');
                }
                return 'Required';
            },
            regex(fieldName) {
                return `The ${fieldName} field format is invalid.`;
            },
            confirmed(fieldName) {
                return `The ${fieldName} confirmation does not match.`;
            },
            email(fieldName) {
                return `The ${fieldName} field must be a valid email.`;
            },
            min_value(fieldName, params) {
                return `The ${fieldName} field must be ${params.min_value} or more.`;
            },
            min_length(fieldName, params) {
                return `The ${fieldName} field must be at least ${params.min} characters.`;
            },
            max_length(fieldName, params) {
                return `The ${fieldName} field must be less than ${params.max} characters.`;
            },
            numeric(fieldName) {
                return `The ${fieldName} field may only contain numeric characters.`;
            },
            date_format_MMYY(fieldName) {
                return `The ${fieldName} field must be in MMYY format.`;
            },
            requiredCheck() {
                return `Required`;
            },
            between(fieldName, params) {
                return `The ${fieldName} field must be between ${params.min} and ${params.max} characters long.`;
            }
        },
        names: {
            'code': __('purchase.promo_code_title'),
            'license_quantity': 'License Quantity',
            'first_name': 'First Name',
            'last_name': 'Last Name',
            'city': 'City',
            'postal_code': 'Postal Code',
            'email': 'Email Address',
        },
    },
    fr: {
        messages: {
            required(fieldName) {
                if (fieldName === 'promotion_code') {
                    return __('errors.invalid_promo_code');
                }
                return 'Requis';
            },
            regex(fieldName) {
                return `Le champ ${fieldName} est invalide.`;
            },
            min_value(fieldName, params) {
                return `Le champ ${fieldName} doit avoir une valeur de ${params.min_value} ou plus.`;
            },
            min_length(fieldName, params) {
                return `Le champ ${fieldName} doit contenir au minimum ${params.min} caractères.`;
            },
            max_length(fieldName, params) {
                return `Le champ ${fieldName} doit contenir au maximum ${params.max} caractères.`;
            },
            email(fieldName) {
                return `Le champ ${fieldName} doit être une adresse courriel valide.`;
            },
            confirmed(fieldName) {
                return `Le champ ${fieldName} ne correspond pas à ${fieldName}.`;
            },
            date_format_MMYY(fieldName) {
                return `Le champ ${fieldName} doit être au format MMYY.`;
            },
            requiredCheck() {
                return `Requis`;
            },
            between(fieldName, params) {
                return `Le champ ${fieldName} doit être entre ${params.min} et ${params.max} caractères.`;
            }
        },
        names: {
            'code': __('purchase.promo_code_title'),
            'license_quantity': 'License Quantity',
            'first_name': 'Prénom',
            'last_name': 'Nom de famille',
            'city': 'ville',
            'postal_code': 'code postal',
            'email': 'Address courriel',
        },
    }
};
const STATE_COOKIE_NAME = 'purchaseState';
const INDICATOR_MINIMUM_OPACITY = '0.05';
const INDICATOR_DISTANCE_OPACITY = [
    '1.00',
    '0.35',
    '0.25',
    '0.15',
    '0.10',
    INDICATOR_MINIMUM_OPACITY
];
const purchaseFlow = [
    { component: 'LicenseQuantity', trackingName: 'NumberOfEmployees' },
    { component: 'BusinessDetails', trackingName: 'BusinessName' },
    { component: 'BusinessUrl', trackingName: 'ProgramURL' },
    { component: 'Terms', trackingName: 'TermsAndConditions' },
];
localize(dictionary);
Vue.use(Notification);
extend('numeric', {
    validate(value) {
        return !isNaN(value);
    },
    params: ['target'],
});
extend('min_value', {
    validate(value, { min_value, target }) {
        return Number(value) >= min_value;
    },
    params: ['min_value', 'target'],
});
extend('min_length', {
    validate(value, { min, target }) {
        return value.length >= min;
    },
    params: ['min', 'target'],
});
extend('max_length', {
    validate(value, { max, target }) {
        return value.length <= max;
    },
    params: ['max', 'target'],
});
extend('required', {
    validate(value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true
});
extend('regex', {
    validate(value, { pattern }) {
        const regex = new RegExp(pattern);
        return regex.test(value);
    },
    params: ['pattern'], // Allows passing a pattern parameter
});
extend('alpha', {
    validate(value) {
        // Check if the value is a valid number
        return /^[a-zA-Z]+$/.test(value);
    },
});
extend('email', {
    validate(value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
        return emailRegex.test(value);
    },
});
extend('confirmed', {
    validate(value, { target }) {
        return value === target;
    },
    params: ['target'], // This allows passing the field to compare against
});
extend('date_format_MMYY', {
    validate(value, { target }) {
        return /^\d{4}$/.test(value) && parseInt(value.substring(0, 2)) >= 1 && parseInt(value.substring(0, 2)) <= 12;
    },
    params: ['target'],
});
extend('between', {
    validate(value, { min, max, target }) {
        const length = value.length;
        return length >= min && length <= max;
    },
    params: ['min', 'max', 'target'], // Accepts both min and max length
});
extend('requiredCheck', {
    validate(value) {
        return value === true || value === "1";
    },
    computesRequired: true
});
export default new Vue({
    el: '#app',
    mixins: [PurchaseFlowMixin],
    data() {
        return {
            numLicenses: "",
            freeLicenses: 0,
            businessDetails: {},
            url: "",
            creditcardReferrals: [],
            invoice: {
                taxPercentage: 0,
                referralName: '',
                referral: {},
                promotionCode: '',
                discountPercentage: 0,
                promotionCodeID: null,
                invoiceAmount: 0,
            },
            showContactFlow: false,
            maxLicenseQuantity: window.s.maxLicenseQuantity,
            purchaseComponents: purchaseFlow,
            taxDetails: [],
            hideInvoice: window.s.hideInvoice
        };
    },
    created() {
        this.getCookies();
        const promotionCodeData = window.s.promotionCode;
        this.setPurchaseFlow(promotionCodeData);
        if (promotionCodeData) {
            this.invoice.referralName = promotionCodeData.referralName;
            this.invoice.referral = promotionCodeData.referral;
            this.invoice.promotionCode = promotionCodeData.code;
            this.invoice.discountPercentage = promotionCodeData.discountRate * 100;
            this.creditcardReferrals = promotionCodeData.creditcardReferrals;
            this.freeLicenses = promotionCodeData.freeLicenses;
            this.invoice.promotionCodeID = promotionCodeData.promotionCodeID;
        }
    },
    mounted() {
        embedSVG();
        this.updatePurchaseFlowIndicator();
        this.sendPageViewHit(this.currentComponentIndex + 1, purchaseFlow[this.currentComponentIndex].trackingName);
    },
    methods: {
        setPurchaseFlow(promotionCodeData) {
            if (promotionCodeData && promotionCodeData.code === "ADP100") {
                purchaseFlow.push({ component: 'DetailVerification', trackingName: 'DetailVerification' });
            }
            else {
                // Please don't change the splice Index as it will change order of pages
                // in SMB Purchase Flow
                purchaseFlow.splice(3, 0, { component: 'BillingDetails', trackingName: 'BillingInformation' });
                purchaseFlow.push({ component: 'CardInformation', trackingName: 'Payment' });
            }
        },
        componentWillAnimate() {
            this.toggleButtons(true);
        },
        componentDidAnimate() {
            this.updatePurchaseFlowIndicator(this.currentComponentIndex);
            this.toggleButtons(false);
        },
        getImageLink(imageFileName) {
            return `${window.s.assetPath}/${imageFileName}`;
        },
        nextComponent() {
            if (this.currentComponentIndex >= purchaseFlow.length) {
                return;
            }
            this.setLastComponentIndex();
            this.componentWillAnimate();
            this.currentComponentIndex++;
            if (window.v._componentAnimationTimer) {
                clearTimeout(window.v._componentAnimationTimer);
            }
            window.v._componentAnimationTimer = setTimeout(() => {
                this.componentDidAnimate();
            }, 500);
            this.sendPageViewHit(this.currentComponentIndex + 1, purchaseFlow[this.currentComponentIndex].trackingName);
            this.setCookies();
        },
        nextButtonDidClick(e) {
            this.$refs.currentComponentRef.formWillSubmit(e);
        },
        toggleButtons(hide = true) {
            embedSVG();
            if (hide) {
                if (this.$refs.nextButton) {
                    this.$refs.nextButton.classList.add('purchase-buttons-enter');
                }
                if (this.$refs.backButton) {
                    this.$refs.backButton.classList.add('purchase-buttons-enter');
                }
            }
            else {
                if (this.$refs.nextButton) {
                    this.$refs.nextButton.classList.remove('purchase-buttons-enter');
                }
                if (this.$refs.backButton) {
                    this.$refs.backButton.classList.remove('purchase-buttons-enter');
                }
            }
        },
        backButtonDidClick() {
            if (this.showContactFlow === true) {
                this.currentComponentIndex = 0;
                this.lastComponentIndex = 0;
                this.showContactFlow = false;
            }
            else {
                this.previousComponent();
            }
        },
        getCookies() {
            if (Cookies.get('venngo_cookies')) {
                const venngoCookies = JSON.parse(Cookies.get('venngo_cookies'));
                if (venngoCookies.smbCookies) {
                    const smbCookies = venngoCookies.smbCookies;
                    this.numLicenses = smbCookies.numLicenses;
                    this.freeLicenses = smbCookies.freeLicenses;
                    this.businessDetails = smbCookies.businessDetails;
                    this.url = smbCookies.url;
                    this.billingDetails = smbCookies.billingDetails;
                    this.invoice = smbCookies.invoice;
                    // Make sure you get the correct referral Name from Cookies
                    this.invoice.referralName = window.l.locale === "en" ? smbCookies.invoice.referral.name : smbCookies.invoice.referral.name_fr;
                    this.lastComponentIndex = smbCookies.lastComponentIndex;
                    this.currentComponentIndex = smbCookies.currentComponentIndex;
                    this.creditcardReferrals = smbCookies.creditcardReferrals;
                }
            }
        },
        removePaymentCookies() {
            Object.keys(Cookies.get()).forEach((cookie) => {
                Cookies.remove(cookie);
            });
        },
        contactWillShow() {
            this.showContactFlow = true;
        },
        businessDetailsDidSubmit(businessDetails) {
            this.businessDetails = businessDetails;
            this.nextComponent();
        },
        urlDidSubmit(url) {
            axios.post(window.s.API.urlCheck, {
                url
            }).then(response => {
                const responseData = response.data;
                if (responseData.success) {
                    this.url = url;
                    this.nextComponent();
                }
                else {
                    this.$notify({
                        'title': this.__('errors.url_exists_title'),
                        'message': this.__('errors.url_exists_message'),
                        'status': 'danger'
                    });
                }
            }, () => {
                this.$notify({
                    'title': this.__('errors.url_exists_title'),
                    'message': this.__('errors.url_exists_message'),
                    'status': 'danger'
                });
            });
        },
        quantityDidUpdate(numLicenses, showContact, nextComponent = false) {
            if (parseInt(numLicenses) > this.maxLicenseQuantity && showContact) {
                this.showContactFlow = true;
            }
            else {
                this.numLicenses = numLicenses;
            }
            if (nextComponent) {
                this.nextComponent();
            }
        },
        netPriceDidUpdate(data) {
            this.invoice.invoiceAmount = data;
        },
        applyPromoCode(code, form) {
            axios.post(window.s.API.promotionCodeCheckAPI, {
                'promoCode': code,
            }).then(response => {
                const responseData = response.data;
                if (responseData.success) {
                    this.freeLicenses = responseData.freeLicenses;
                    this.invoice.referralName = responseData.referralName;
                    this.invoice.promotionCode = code;
                    this.invoice.referral = responseData.referral;
                    this.creditcardReferrals = responseData.creditcardReferrals;
                    this.invoice.discountPercentage = responseData.discountRate * 100;
                    this.invoice.promotionCodeID = responseData.promotionCodeID;
                    this.setCookies();
                }
                else {
                    form.setErrors({ 'promotion_code': responseData.error });
                }
            }, (error) => {
                console.log(error);
            });
        },
        processPayment() {
            return axios.post(window.s.API.processPayment, {
                'purchase': {
                    numLicenses: this.numLicenses,
                    freeLicenses: this.freeLicenses,
                    businessDetails: this.businessDetails,
                    url: this.url,
                    billingDetails: this.billingDetails,
                    cardInformation: this.cardInformation,
                    invoice: this.invoice,
                },
            }).then((response) => {
                if (response.data.success) {
                    this.sendPageViewHit(7, "Complete");
                    this.removePaymentCookies();
                    this.$notify({
                        'title': this.__('purchase.payment_success_title'),
                        'message': this.__('purchase.payment_success_message'),
                        'status': 'success'
                    });
                    let venngoCookies = Cookies.get('venngo_cookies');
                    if (venngoCookies) {
                        venngoCookies = JSON.parse(venngoCookies);
                    }
                    else {
                        venngoCookies = {};
                    }
                    venngoCookies.userId = response.data.userId;
                    Cookies.set('venngo_cookies', JSON.stringify(venngoCookies), { expires: 1 / 24 });
                    // Cookies.set('invoiceId',response.data.invoiceId, { expires: 1/24 });
                    navigateToUrl('/payment/confirmation');
                }
                else {
                    this.$notify({
                        'title': this.__('errors.invalid_card_title'),
                        'message': response.data.error,
                        'status': 'danger'
                    });
                }
            }).catch((error) => {
                this.$notify({
                    'title': this.__('errors.error_occured_title'),
                    'message': this.__('errors.error_occured_message'),
                    'status': 'danger'
                });
                console.log(error);
            }).then(() => { Swal.close(); });
        },
        updatePurchaseFlowIndicator(indicator) {
            const currentIndicatorIndex = indicator || this.currentComponentIndex;
            for (let index = 0; index < purchaseFlow.length; index++) {
                this.setPurchaseFlowIndicator(index, INDICATOR_DISTANCE_OPACITY[Math.abs(currentIndicatorIndex - index)]);
            }
        },
        setPurchaseFlowIndicator(indicatorIndex, opacity) {
            const element = this.$refs[`purchase__flow-indicator-${indicatorIndex}`];
            if (element) {
                element.style.opacity = opacity;
            }
        },
        sendPageViewHit(viewIndex, viewLabel) {
            gtag('event', 'PurchaseFlowView', {
                'event_category': this.invoice.promotionCode && this.invoice.promotionCode.length > 0 ? `WorkperksSMB-${this.invoice.promotionCode}` : 'WorkperkSMB',
                'event_label': viewLabel,
                'value': viewIndex
            });
        },
        previousComponent() {
            this.componentWillAnimate();
            if (this.currentComponentIndex === this.lastComponentIndex || this.currentComponentIndex < this.lastComponentIndex) {
                this.currentComponentIndex--;
            }
            else {
                this.currentComponentIndex = this.lastComponentIndex;
            }
            window.v._componentAnimationTimer = setTimeout(() => {
                this.componentDidAnimate();
            }, 500);
        },
        setCookies() {
            if (this.numLicenses <= this.maxLicenseQuantity) {
                const smbCookies = {
                    numLicenses: this.numLicenses,
                    businessDetails: this.businessDetails,
                    url: this.url,
                    billingDetails: this.billingDetails,
                    cardInformation: this.cardInformation,
                    invoice: this.invoice,
                    lastComponentIndex: this.lastComponentIndex,
                    currentComponentIndex: this.currentComponentIndex,
                    creditcardReferrals: this.creditcardReferrals,
                };
                let venngoCookies = Cookies.get('venngo_cookies');
                if (venngoCookies) {
                    venngoCookies = JSON.parse(venngoCookies);
                }
                else {
                    venngoCookies = {};
                }
                venngoCookies.smbCookies = smbCookies;
                Cookies.set('venngo_cookies', JSON.stringify(venngoCookies), { expires: 1 / 24 });
            }
        },
    },
    components: {
        LicenseQuantity,
        BusinessDetails,
        BusinessUrl,
        BillingDetails,
        Terms,
        CardInformation,
        DetailVerification,
        Invoice,
        Contact,
        ValidationProvider,
        ValidationObserver,
    }
});
